export const pageTexts = (t) => {
  const NUMBER = 12; // 12 title + text on the Privacy Policy Page
  let termsText = [];
  for (let i = 1; i <= NUMBER; i++) {
    termsText.push({
      text: t("privacy-policy-members." + i + "title"),
      colorClass: "colorDark",
      textType: "subtitle",
      extraClass: "font18 pt-20 fontWeightBold",
    });
    termsText.push({
      text: t("privacy-policy-members." + i + "text"),
      colorClass: "colorDark",
      extraClass: "font14 lineHeight1_7 termsStyle",
      textType: "paragraph",
      heading: "div",
    });
  }

  return {
    topTitle: {
      title: {
        text: t("privacy-policy-members.privacyTitle"),
        colorClass: "colorDark",
        extraClass: "font26 text-center",
        heading: "h1",
      },
      text: {
        text: t("privacy-policy-members.version"),
        colorClass: "colorDark",
        extraClass: "font14 text-center",
      },
      separator: false,
    },
    terms: termsText,
  };
};
